export const enum LoginUIMode {
    SIGN_IN = 1,
    SIGN_UP,
    FORGOT_PASSWORD,
  }